import { HeaderCellProps } from '../types';

export const TenantNameHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <div>Tenant Name</div>;
};
